// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay])

window.addEventListener('DOMContentLoaded', function () {
  const carouselBlock = document.querySelectorAll('.wp-block-acf-carousel')
  carouselBlock.forEach(carousel => {
    const desktopSlides = carousel.dataset.desktopSlides
    const tabletSlides = carousel.dataset.tabletSlides
    const mobileSlides = carousel.dataset.mobileSlides

    // init Swiper:
    const swiper = new Swiper('.wp-block-acf-carousel', {
      loop: true,
      slidesPerView: mobileSlides,
      spaceBetween: 20,
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: false,
        disableOnInteraction: false,
        reverseDirection: false
      },

      // bullets
      pagination: {
        el: '.swiper-pagination'
      },

      // arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },

      // responsive
      breakpoints: {
        768: {
          slidesPerView: tabletSlides
        },
        1024: {
          slidesPerView: desktopSlides
        }
      }
    })
  })
})
